export default {
  text: 'Ganaste {{points}} puntos ({{amount}}) en este pedido',
  button: 'Iniciar sesión y reclamar puntos',
};
